import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Link } from 'react-router-dom';
import SlickSlider from './SlickSlider';
import './SideInPanel.css'; // Import the CSS file for the sliding panel

const Header = () => {
  const [isNavOpen, setIsNavOpen] = useState(false);
  const [isPanelOpen, setIsPanelOpen] = useState(false);

  const toggleNav = () => {
    setIsNavOpen(!isNavOpen);
  };

  const closeNav = () => {
    setIsNavOpen(false);
  };

  const togglePanel = () => {
    setIsPanelOpen(!isPanelOpen); // Toggle the sliding panel visibility
  };

  return (
    <>
      <header>
        <div className=''>
          <div className="header1">
            <div className="container-fluid row text-center pt-2 pb-2">
              <div className="col-12 col-lg-6 text-center header2">
                <a href="tel:+91 9763888448" className="text-white fw-bold">
                  <i className="bi bi-telephone-fill me-2"></i>
                  <span>+91 9763888448</span>
                </a>
                <a href="tel:+91 9922248255" className="text-white fw-bold">
                  <i className="bi bi-telephone-fill ms-3"></i>
                  <span>+91 9922248255</span>
                </a>
              </div>
              <div className="col-12 col-lg-4">
                <a href="mailto:omsaipgpune@gmail.com" className="text-white fw-bold">
                  <i className="bi bi-envelope me-2"></i>
                  <span>omsaipgpune@gmail.com</span>
                </a>
              </div>
            </div>
          </div>

          <nav className="navbar navbar-expand-lg">
            <div className="container-fluid">
              <Link className="navbar-brand" to="/">
                <img src="img/logo/logo.jpg" alt="logo" className='img-fluid' />
              </Link>
              <button
                className="navbar-toggler"
                type="button"
                onClick={toggleNav}
                aria-controls="navbarSupportedContent"
                aria-expanded={isNavOpen ? 'true' : 'false'}
                aria-label="Toggle navigation"
              >
                <span className="navbar-toggler-icon"></span>
              </button>
              <div className={`collapse navbar-collapse ${isNavOpen ? 'show' : ''}`} id="navbarSupportedContent">
                <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                  <li className="nav-item">
                    <Link className="nav-link active" aria-current="page" to="/" onClick={closeNav}>Home</Link>
                  </li>

                  <li className="nav-item dropdown">
                    <Link className="nav-link dropdown-toggle active" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                      About
                    </Link>
                    <ul className="dropdown-menu">
                      <li><Link className="dropdown-item" to="/about" onClick={closeNav}>About Us</Link></li>
                      <li><Link className="dropdown-item" to="/Terms-and-condition" onClick={closeNav}>Terms & Condition</Link></li>
                      <li><Link className="dropdown-item" to="/privacy-and-policy" onClick={closeNav}>Privacy & Policy</Link></li>
                    </ul>
                  </li>

                  <li className="nav-item">
                    <Link className="nav-link active" aria-current="page" to="/room" onClick={closeNav}>Room</Link>
                  </li>

                  <li className="nav-item">
                    <Link className="nav-link active" aria-current="page" to="/Teriff-plan" onClick={closeNav}>Teriff Plan</Link>
                  </li>
                  <li className="nav-item">
                    <Link className="nav-link active" aria-current="page" to="/Gallery" onClick={closeNav}>Gallery</Link>
                  </li>

                  <li className="nav-item">
                    <Link className="nav-link active" aria-current="page" to="/amenities" onClick={closeNav}>Amenities</Link>
                  </li>

                  <li className="nav-item">
                    <Link className="nav-link active" aria-current="page" to="/Services" onClick={closeNav}>Services</Link>
                  </li>

                  <li className="nav-item">
                    <Link className="nav-link active" aria-current="page" to="/contact" onClick={closeNav}>Contact Us</Link>
                  </li>
                  <li className="nav-item">
                    <Link className="nav-link active" aria-current="page" to="/enquiry" onClick={closeNav}>Enquiry</Link>
                  </li>

                  <li>
                  <button className="btn pg-btn" onClick={togglePanel}>
                Om Sai PG 
          </button>
                  </li>
                </ul>
              </div>
            </div>
          </nav>

          {/* Add the button to trigger the sliding panel */}
          

          {/* Sliding Panel Component */}
          <div className={`slide-panel ${isPanelOpen ? 'open' : ''}`}>
            <div className="panel-content">
              <h2>Om Sai PG</h2>
              <p className='text-black'>Address: Tulja Bhavani Nagar, Lane No 7, Near Durga Mata Mandir, Kharadi, Pune - 411014</p>
              <div style={{ position: 'relative', overflow: 'hidden', paddingTop: '', height: '200px', maxWidth: '100%', marginBottom:'20px' }}>
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d56881.68616005074!2d73.88729343290177!3d18.55597545061753!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2c3f1982d6b2b%3A0x74125aedd2bd98c6!2sOM%20SAI%20PG!5e1!3m2!1sen!2sin!4v1740637774676!5m2!1sen!2sin"
        width="100%"
        height="100%"
        style={{ border: 0 }}
        allowFullScreen
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        title="Om Sai PG Location"
      ></iframe>
    </div>
            <p className='text-black fw-bold fs-5'>Contact:-  <a href="tel:+91 9763888448" className='phone-text text-decoration-none'>+91 9763888448</a>  / <a href="tel:+91 9922248255" className='phone-text text-decoration-none'> +91 9922248255</a></p>



              <h3 className='text-purple'>Sharing Room</h3>
              <ul>
                <li className='text-black'>1) 8,500/- (including breakfast and dinner) </li>
                <li className='text-black'>2) 7,000/- (including breakfast and dinner) </li>
                <li className='text-black'>3) 6,000/- (including breakfast and dinner) </li>
              </ul>
   
              {/* Images of PG */}
              <div className="image-gallery">
                <img src="img/rooms/room3.jpg" alt="PG Image 1" />
                <img src="img/rooms/room14.jpg" alt="PG Image 2" />
                <img src="img/rooms/room10.jpg" alt="PG Image 3" />
                <img src="img/rooms/room5.jpg" alt=""/>
              </div>

              {/* PG Facilities */}
              <h3 className='text-purple'>Facilities</h3>
              <ul>
                <li>Fully Furnished Rooms</li>
                <li>Free Wi-Fi</li>
                <li>24/7 Security</li>
                <li>Home-Cooked Meals</li>
                <li>Air-conditioned Rooms</li>
                <li>Common Lounge Area</li>
              </ul> 

    <div>
    <Link to='https://api.whatsapp.com/send/?phone=9922248255&text=I would like to inquire about booking a room at your Om Sai PG. Kindly provide me with more details or contact me . Thank you!!!' target='_blank' className="side-btn" >
                                Book Now
                              </Link>
    </div>
               
            </div>

            {/* Close Button */}
            <button className="close-btn" onClick={togglePanel}>
              Close
            </button>
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;
